import { POLYGON_TYPES } from "./GoogleMapGeoFence";
export const convertGmapPathToGeoJSONPath = (polygons) => {
    const geoJSONPolygons = [];
    polygons.forEach((poly) => {
        const coords = [];
        for (const point of poly.path) {
            coords.push([point.lng, point.lat]);
        }
        const closedCoords = coords.length > 0 &&
            (coords[0][0] !== coords[coords.length - 1][0] || coords[0][1] !== coords[coords.length - 1][1])
            ? [...coords, [coords[0][0], coords[0][1]]]
            : coords;
        geoJSONPolygons.push({
            geofenceId: poly.geofenceId,
            geofenceType: poly.geofenceType,
            path: closedCoords
        });
    });
    return geoJSONPolygons;
};
export const getGeofenceTypeName = (geofenceType) => {
    switch (geofenceType) {
        case POLYGON_TYPES.PROJECT_AREA:
            return "Project Area";
        case POLYGON_TYPES.JOB_SITE:
            return "Job Site";
        case POLYGON_TYPES.CHARGE_STATION:
            return "Charge Station";
        default:
            return "Unknown";
    }
};
